export default __webpack_public_path__ + "static/media/eye-slash-regular.9d035b23.svg";